import * as React from 'react';
import { AlgoliaAnalytics } from '@grandvisionhq/analytics';
import { useFeatureToggles } from '@grandvisionhq/state';
import { usePlpDatalayerEvents } from '../../../../DataLayer/hooks/use-plp-datalayer-events.js';
import '../../../../lib-components/FeaturedProducts/FeaturedProducts.js';
import '@swc/helpers';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/utils';
import '../../../../lib-components/ProductBlock/types.js';
import '@grandvisionhq/frk-routing';
import '../../../../lib-components/ProductBlock/utils/get-variant-images.js';
import { ExtendedProductBlock } from '../../../../lib-components/ProductBlock/containers/ExtendedProductBlock.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/inventory';
import '@grandvisionhq/api-client';
import { ProductListingBlock } from '../../../../lib-components/ProductListingBlock/ProductListingBlock.js';
import '@grandvisionhq/content';
import '@grandvisionhq/fun-products';
import '@grandvisionhq/svc-monetate';
import '@grandvisionhq/reviews';
import 'react-intersection-observer';
import '@grandvisionhq/forms';
import '@grandvisionhq/shipping';
import '../../../../ProductDetail/Lenses/components/ConfigureContactLenses/ConfigureContactLensesContainer.js';
import '../../../../ProductDetail/Lenses/components/ConfigureContactLenses/components/PackageQuantity/PriceAside.js';
import 'framer-motion';
import '../../../../lib-components/RecentlyViewedProducts/RecentlyViewedProducts.js';

const ProductListingBlockWrapper = ({ product: product1 , index: index1 , reimbursableLogos , forwardedQueryParams ,  })=>{
    const { isRestructuredProductBlockEnabled  } = useFeatureToggles();
    const { addImpressionEvent , pushProductClickToDatalayer  } = usePlpDatalayerEvents();
    const onProductBlockClick = React.useCallback((product, index, handleSearchAnalytics)=>{
        handleSearchAnalytics(product.objectID, index);
        pushProductClickToDatalayer(product, index);
    }, [
        pushProductClickToDatalayer
    ]);
    return /*#__PURE__*/ React.createElement(AlgoliaAnalytics, null, (handleSearchAnalytics)=>{
        if (isRestructuredProductBlockEnabled) {
            return /*#__PURE__*/ React.createElement(ProductListingBlock, {
                listingProduct: product1,
                onImpression: ()=>{
                    return addImpressionEvent === null || addImpressionEvent === void 0 ? void 0 : addImpressionEvent(product1, index1);
                },
                onInteraction: ()=>onProductBlockClick(product1, index1, handleSearchAnalytics)
                ,
                reimbursableLogos: reimbursableLogos,
                productLocation: "plp"
            });
        }
        return /*#__PURE__*/ React.createElement(ExtendedProductBlock, {
            className: "product-listing-product-block",
            product: product1,
            onClick: ()=>onProductBlockClick(product1, index1, handleSearchAnalytics)
            ,
            reimbursableLogos: reimbursableLogos,
            additionalUrlParams: forwardedQueryParams,
            onImpression: ()=>{
                return addImpressionEvent === null || addImpressionEvent === void 0 ? void 0 : addImpressionEvent(product1, index1);
            },
            productLocation: "plp"
        });
    });
};

export { ProductListingBlockWrapper };
//# sourceMappingURL=ProductListingBlockWrapper.js.map
